export default function Timestamp({ value }) {
  const d = new Date(value.seconds * 1000);
  return (
    <span>
      {d.getDate()}.{d.getMonth() + 1}.{d.getFullYear()}
    </span>
  );
}
